// Copyright (c) StrangeBee 2023

import React, { ReactElement, ReactNode } from 'react';
import { ICONS } from '@Constants/iconsApp';
import { copyToClipboard } from '@Helpers/copy';
import { useLocalMessage } from '@Helpers/locale';
import { classList } from '@Helpers/className';

import './CopyValue.scss';

interface CopyValueProps extends React.HTMLAttributes<HTMLSpanElement> {
    children: ReactNode;
    value: string;
    className?: string;
    clickOnContainer?: boolean;
    disabled?: boolean;
    block?: boolean;
}

export const CopyValue = ({
    children,
    value,
    className,
    clickOnContainer = true,
    disabled,
    block,
    ...props
}: CopyValueProps): ReactElement => {
    const i = useLocalMessage();

    const handleClick = !disabled ? () => copyToClipboard(value, i('notification.copy')) : undefined;

    return (
        <span
            className={classList(className, 'copy-value', { 'copy-value--block': block })}
            onClick={clickOnContainer ? handleClick : undefined}
            role={clickOnContainer ? 'button' : undefined}
            {...props}
        >
            {children}

            {!disabled && (
                <ICONS.CloneIcon
                    className={'copy-value__icon'}
                    onClick={!clickOnContainer ? handleClick : undefined}
                    role={!clickOnContainer ? 'button' : undefined}
                />
            )}
        </span>
    );
};
